import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import type { Block } from "@/types/proposals";

interface LineItemsTableProps {
  block: Block;
  onUpdate: (updates: Partial<Block>) => void;
  onSelect: () => void;
  smartFieldData?: Record<string, any>;
}

export function LineItemsTable({ block, onSelect, smartFieldData }: LineItemsTableProps) {
  const { items = [], showUnitPrice, showQuantity, showTotal, useDynamicData } = block.content;
  
  // Use dynamic data from estimate if available
  const displayItems = useDynamicData && smartFieldData?.lineItems 
    ? smartFieldData.lineItems.map((item: any) => ({
        name: item.description,
        quantity: item.quantity,
        unit_price: item.unit_price,
        total: item.total
      }))
    : items;

  return (
    <div className="cursor-pointer hover:ring-2 hover:ring-primary/50 transition-all rounded p-4" onClick={onSelect}>
      {useDynamicData && !smartFieldData?.lineItems ? (
        <div className="text-center py-12 text-muted-foreground border-2 border-dashed rounded bg-blue-50">
          <p className="font-semibold">📊 Dynamic Line Items</p>
          <p className="text-sm mt-1">Will auto-populate from estimate when linked to a job</p>
        </div>
      ) : displayItems.length === 0 ? (
        <div className="text-center py-12 text-muted-foreground border-2 border-dashed rounded">
          <p>No line items added</p>
          <p className="text-sm mt-1">Click to add items</p>
        </div>
      ) : (
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Item</TableHead>
              {showQuantity && <TableHead>Qty</TableHead>}
              {showUnitPrice && <TableHead>Unit Price</TableHead>}
              {showTotal && <TableHead className="text-right">Total</TableHead>}
            </TableRow>
          </TableHeader>
          <TableBody>
            {displayItems.map((item: any, index: number) => (
              <TableRow key={index}>
                <TableCell>{item.name}</TableCell>
                {showQuantity && <TableCell>{item.quantity}</TableCell>}
                {showUnitPrice && <TableCell>${item.unit_price?.toFixed(2)}</TableCell>}
                {showTotal && <TableCell className="text-right">${item.total?.toFixed(2)}</TableCell>}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
}
